import * as authApi from '../../api/authApi';
import TOKEN from '../../constants';

const LOGIN = 'efes/auth/LOGIN';
const LOGIN_SUCCESS = 'efes/auth/LOGIN_SUCCESS';

const LOGIN_FAIL = 'efes/auth/LOGIN_FAIL';
const LOGOUT = 'efes/auth/LOGOUT';
export const LOGOUT_SUCCESS = 'efes/auth/LOGOUT_SUCCESS';

const REFRESH_TOKEN_FAIL = 'efes/auth/REFRESH_TOKEN_FAIL';

const SIGN_UP = 'efes/auth/SIGN_UP';
const SIGN_UP_SUCCESS = 'efes/auth/SIGN_UP_SUCCESS';
const SIGN_UP_FAIL = 'efes/auth/SIGN_UP_FAIL';

const RECOVER_PASSWORD = 'efes/auth/RECOVER_PASSWORD';
const RECOVER_PASSWORD_SUCCESS = 'efes/auth/RECOVER_PASSWORD_SUCCESS';
const RECOVER_PASSWORD_FAIL = 'efes/auth/RECOVER_PASSWORD_FAIL';

const SEND_RECOVERY_LINK = 'efes/auth/SEND_RECOVERY_LINK';
const SEND_RECOVERY_LINK_SUCCESS = 'efes/auth/SEND_RECOVERY_LINK_SUCCESS';
const SEND_RECOVERY_LINK_FAIL = 'efes/auth/SEND_RECOVERY_LINK_FAIL';

const CLEAR_SENT_MAIL = 'efes/auth/CLEAR_SENT_MAIL';

const MUST_TO_LOG_OUT = 'efes/auth/MUST_TO_LOG_OUT';

const setToken = (token) => {
  localStorage.setItem(TOKEN, token);
};

const removeToken = () => {
  localStorage.removeItem(TOKEN);
};

const initialState = {
  mailSent: false,
  isAuthenticated: false,
  isLoading: false,
  isSigningUp: false,
  loginError: null,
  mustToLogOut: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        isLoading: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isLoading: false,
        loginError: action.error,
        isAuthenticated: false,
      };
    case LOGOUT:
      return {
        ...state,
        isLoading: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
      };
    case REFRESH_TOKEN_FAIL:
      return {
        ...state,
        isLoading: false,
        isAuthenticated: false,
      };
    case SIGN_UP:
      return {
        ...state,
        isSigningUp: true,
      };
    case SIGN_UP_SUCCESS:
      return {
        ...state,
        isSigningUp: false,
        isAuthenticated: true,
      };
    case SIGN_UP_FAIL:
      return {
        ...state,
        isSigningUp: false,
      };
    case RECOVER_PASSWORD:
      return {
        ...state,
        recoveringPass: true,
      };
    case RECOVER_PASSWORD_SUCCESS:
      return {
        ...state,
        recoveringPass: false,
      };
    case RECOVER_PASSWORD_FAIL:
      return {
        ...state,
        recoveringPass: false,
        recoverUserError: action.error,
      };

    case SEND_RECOVERY_LINK:
      return {
        ...state,
        isLoading: true,
      };
    case SEND_RECOVERY_LINK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        mailSent: true,
      };
    case SEND_RECOVERY_LINK_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error,
        mailSent: false,
      };

    case CLEAR_SENT_MAIL:
      return {
        ...state,
        mailSent: false,
      };

    case MUST_TO_LOG_OUT:
      return {
        ...state,
        mustToLogOut: action.data,
      };

    default:
      return state;
  }
}

export function clearSentMail() {
  return {
    type: CLEAR_SENT_MAIL,
  };
}

export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  };
}

export function login(credentials) {
  return {
    actions: [
      { type: LOGIN },
      { type: LOGIN_SUCCESS },
      { type: LOGIN_FAIL, showError: true, customMsg: 'loginFailed' },
    ],
    promise: authApi.login(credentials).then((resp) => setToken(resp.token)),
  };
}

export function logoutSuccess() {
  removeToken();

  return {
    type: LOGOUT_SUCCESS,
  };
}

export function logout() {
  return (dispatch) => {
    authApi.logout();
    dispatch(logoutSuccess());
  };
}

export function setMustToLogOut(mustToLogOut) {
  return {
    type: MUST_TO_LOG_OUT,
    data: mustToLogOut,
  };
}

export function refreshingTokenFail() {
  return {
    type: REFRESH_TOKEN_FAIL,
  };
}

export function signUp(data) {
  return {
    actions: [
      { type: SIGN_UP },
      { type: SIGN_UP_SUCCESS },
      { type: SIGN_UP_FAIL, showError: true },
    ],
    promise: authApi.signup(data).then((resp) => setToken(resp.token)),
  };
}

export function recoverPassword(data) {
  return {
    actions: [
      { type: RECOVER_PASSWORD },
      { type: RECOVER_PASSWORD_SUCCESS },
      { type: RECOVER_PASSWORD_FAIL, showError: true },
    ],
    promise: authApi.reset(data),
  };
}

export function sendRecoveryLink(email) {
  return {
    actions: [
      { type: SEND_RECOVERY_LINK },
      { type: SEND_RECOVERY_LINK_SUCCESS },
      { type: SEND_RECOVERY_LINK_FAIL, showError: true },
    ],
    promise: authApi.sendRecoveryLink(email),
  };
}
